// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lnk-disabled[data-v-89606380] {\n  color: #777;\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
